// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:32:00.017Z
// Property: Terra View (ID: 6767906449167755)
// Collections: 34 POIs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167755",
  "property_external_id": "2484082",
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57146748823",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "terra-view",
  "property_name": "Terra View",
  "property_website_url": "https://www.live-terraview.com/",
  "property_domain": "https://www.live-terraview.com/",
  "property_address": "31725 Co Rd 52",
  "property_full_address": "31725 Co Rd 52, San Antonio, FL 33576",
  "property_address_1": "31725 Co Rd 52",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "FL",
  "property_address_zip_full": "33576",
  "property_address_zip": "33576",
  "property_address_country": "US",
  "property_address_county": "Pasco County",
  "property_neighborhood_address": null,
  "property_address_latitude": "28.3329487",
  "property_address_longitude": "-82.29152599999999",
  "property_email": null,
  "property_phone": "(470) 982-3608",
  "property_call_tracking_phone": null,
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "Feel at home at Terra View, a brand-new rental townhome community by Quinn Residences in peaceful San Antonio, Florida. Designed with modern living in mind, these spacious townhomes feature upscale finishes including granite countertops, luxury flooring, stainless steel appliances, and smart-home technology for everyday convenience and comfort.",
  "property_long_description": "Feel at home at Terra View, a brand-new rental townhome community by Quinn Residences in peaceful San Antonio, Florida. Designed with modern living in mind, these spacious townhomes feature upscale finishes including granite countertops, luxury flooring, stainless steel appliances, and smart-home technology for everyday convenience and comfort. Each home is equipped with state-of-the-art smart technology, high-end finishes chosen for a living experience that is both luxurious and comfortable, and maintenance-free living: Quinn handles the yard work, exterior maintenance, and repairs. Nestled just off I-75, Terra View offers easy access to nearby Wesley Chapel, Tampa, and the scenic beauty of Pasco County. Whether you're relaxing at home or exploring local parks, shops, and eateries, Terra View is where modern comfort meets Florida charm.",
  "property_featured_image": null,
  "property_featured_image_media": null,
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "169",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "null",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://quinnmgmt-rentcafewebsite.securecafe.com/onlineleasing/terra-view0/floorplans.aspx",
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#0d475d",
  "property_secondary_color": "#e6874b",
  "property_font_color": "#0d475d",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJwQlzF-etwogR3XLehwjcr0g",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Terra View",
  "property_home_romance_title": "Embrace the Life You Love in Your New Townhome",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": null,
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Nestled just off I-75, Terra View offers easy access to nearby Wesley Chapel, Tampa, and the scenic beauty of Pasco County. Whether you're relaxing at home or exploring local parks, shops, and eateries, Terra View is where modern comfort meets Florida charm.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": null,
  "property_applynow_blurb": null,
  "property_contactus_blurb": null,
  "property_faqs_blurb": null,
  "property_floorplans_blurb": null,
  "property_gallery_blurb": null,
  "property_interactivemap_blurb": null,
  "property_pets_blurb": null,
  "property_referafriend_blurb": null,
  "property_residentaccess_blurb": null,
  "property_reviews_blurb": null,
  "property_created_at": "1788965992620",
  "property_scheduletour_blurb": null,
  "property_thankyou_blurb": null,
  "property_virtualtours_blurb": null,
  "property_copyright": null,
  "property_seo_title_home": null,
  "property_seo_description_home": null,
  "property_seo_title_floorplans": null,
  "property_seo_description_floorplans": null,
  "property_seo_title_amenities": null,
  "property_seo_description_amenities": null,
  "property_seo_title_gallery": null,
  "property_seo_description_gallery": null,
  "property_seo_title_virtualtours": null,
  "property_seo_description_virtualtours": null,
  "property_seo_title_interactivemap": null,
  "property_seo_description_interactivemap": null,
  "property_seo_title_neighborhood": null,
  "property_seo_description_neighborhood": null,
  "property_seo_title_contact": null,
  "property_seo_description_contact": null,
  "property_seo_title_faqs": null,
  "property_seo_description_faqs": null,
  "property_seo_title_reviews": null,
  "property_seo_description_reviews": null,
  "property_seo_title_applynow": null,
  "property_seo_description_applynow": null,
  "property_seo_title_residentaccess": null,
  "property_seo_description_residentaccess": null,
  "property_seo_title_referafriend": null,
  "property_seo_description_referafriend": null,
  "property_seo_title_scheduletour": null,
  "property_seo_description_scheduletour": null,
  "property_seo_title_privacy": null,
  "property_seo_description_privacy": null,
  "property_seo_title_accessibility": null,
  "property_seo_description_accessibility": null,
  "property_seo_title_sitemap": null,
  "property_seo_description_sitemap": null,
  "property_seo_title_thankyou": null,
  "property_seo_description_thankyou": null,
  "property_seo_title_pets": "Pet Policy | Townhomes for Rent in San Antonio, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793289335581",
  "amenities": [],
  "photo_gallery": [],
  "neighborhood_pois": [
    {
      "id": "custom_7baa20fe-bee5-4c27-8c2d-4088fef28d85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "On Q Smokehouse Grill",
      "poi_type": "Restaurants",
      "poi_address": "33030 Co Rd 52, San Antonio, FL 33576, USA",
      "poi_short_description": "Modest outlet with porch seating & a menu of smoked meat, sandwiches, seafood & wings.",
      "poi_long_description": "Modest outlet with porch seating & a menu of smoked meat, sandwiches, seafood & wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b0-feee-7655-b8f2-37c827d2b9a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b0-feee-7655-b8f2-37c827d2b9a8",
        "storage_key": "property/6767906449167755/01a086b0-feee-7655-b8f2-37c827d2b9a8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.onqsmokehousegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11823955223485578729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-q-smokehouse-grill",
      "poi_latitude": "28.335232",
      "poi_longitude": "-82.269234",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-668-4821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0r9Ml2swogR6X37N6EgF6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_3e20d745-95d1-4508-95b3-b351895fa7be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Pancho's Villa Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "32804 Pennsylvania Ave, San Antonio, FL 33576, USA",
      "poi_short_description": "Longtime, busy joint offering classic plates of Mexican fare & patio seating in a laid-back setting.",
      "poi_long_description": "Longtime, busy joint offering classic plates of Mexican fare & patio seating in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-c2fe-71dc-9e75-94ec6bdbd03f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-c2fe-71dc-9e75-94ec6bdbd03f",
        "storage_key": "property/6767906449167755/01a086ae-c2fe-71dc-9e75-94ec6bdbd03f.webp",
        "width": 1193,
        "height": 1254
      },
      "poi_business_url": "https://panchosvillamexican.cfd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3829479706811658686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panchos-villa-mexican-restaurant",
      "poi_latitude": "28.3360061",
      "poi_longitude": "-82.27356329999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-588-3037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbTcP0KswogRvnET_4ALJTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_476ff1d5-4fbb-4e84-ab57-ab6ba8c99731",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Ralph's San Antonio Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "32631 Co Rd 52, San Antonio, FL 33576, USA",
      "poi_short_description": "Casual tavern serving breakfast, comfort food, and small plates with drinks specials.",
      "poi_long_description": "Casual tavern serving breakfast, comfort food, and small plates with drinks specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-0086-72ec-974a-00bb5cc6f2f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-0086-72ec-974a-00bb5cc6f2f8",
        "storage_key": "property/6767906449167755/01a086b1-0086-72ec-974a-00bb5cc6f2f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9836075046559903401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ralphs-san-antonio-restaurant",
      "poi_latitude": "28.332446",
      "poi_longitude": "-82.2762504",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-588-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE4DMNEGswogRqW5JHiTCgIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_ba82a1ac-9838-436b-bc57-b6e0fc350554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Al's Pizza Shop",
      "poi_type": "Restaurants",
      "poi_address": "11931 Curley St, San Antonio, FL 33576, USA",
      "poi_short_description": "Family-run pizzeria serving customizable pies alongside sandwiches, salads & wings in a snug setup.",
      "poi_long_description": "Family-run pizzeria serving customizable pies alongside sandwiches, salads & wings in a snug setup.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-c585-74c2-8479-bff18f5ad9b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-c585-74c2-8479-bff18f5ad9b2",
        "storage_key": "property/6767906449167755/01a086ae-c585-74c2-8479-bff18f5ad9b2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.alspizzashop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15450473570292824736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "als-pizza-shop",
      "poi_latitude": "28.331462",
      "poi_longitude": "-82.27451669999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 352-588-4422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1dXAUSswogRoHrdINoba9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_95865a29-5184-4e93-948b-5ed855f810aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "A Cup of Organic Cafe",
      "poi_type": "Restaurants",
      "poi_address": "33024 Co Rd 52, San Antonio, FL 33576, USA",
      "poi_short_description": "Casual eatery serving coffee freshly brewed, plus muffins, croissants, and bagels.",
      "poi_long_description": "Casual eatery serving coffee freshly brewed, plus muffins, croissants, and bagels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b0-fb00-74b0-b965-3977b4eba9b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b0-fb00-74b0-b965-3977b4eba9b2",
        "storage_key": "property/6767906449167755/01a086b0-fb00-74b0-b965-3977b4eba9b2.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/share/1Bh62EdNzj/?mibextid=wwXIfr",
      "poi_directions_map_url": "https://maps.google.com/?cid=13326382135727752287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-cup-of-organic-cafe",
      "poi_latitude": "28.3351727",
      "poi_longitude": "-82.2698324",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-546-6659",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3db9-70bc-8375-cd784f79b03f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086b1-3db9-70bc-8375-cd784f79b03f",
        "storage_key": "property/6767906449167755/01a086b1-3db9-70bc-8375-cd784f79b03f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJi988xUKswogRXwQqPfLR8Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7fcb1de8-8d36-4fe2-9d8c-2a165594a886",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "The Hungry Greek",
      "poi_type": "Restaurants",
      "poi_address": "30937 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Local counter-serve chain featuring a menu of traditional Greek dishes in relaxed surroundings.",
      "poi_long_description": "Local counter-serve chain featuring a menu of traditional Greek dishes in relaxed surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-c396-7141-b75d-4f4156d7ce72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-c396-7141-b75d-4f4156d7ce72",
        "storage_key": "property/6767906449167755/01a086ae-c396-7141-b75d-4f4156d7ce72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thehungrygreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17842448295153007837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hungry-greek",
      "poi_latitude": "28.3268601",
      "poi_longitude": "-82.2954408",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-668-4412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgwfGVVytwogR3Xze6zAcnfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4549e65a-36b4-4ee5-b99f-6bbe28c3ca58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Tasty Tokyo Japanese Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "30825 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Casual restaurant offering sushi and a variety of Japanese and Chinese meals, including hibachi-grilled items.",
      "poi_long_description": "Casual restaurant offering sushi and a variety of Japanese and Chinese meals, including hibachi-grilled items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b0-fd51-702e-92e2-ed2a757eac6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b0-fd51-702e-92e2-ed2a757eac6c",
        "storage_key": "property/6767906449167755/01a086b0-fd51-702e-92e2-ed2a757eac6c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tastytokyo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9345241803401368939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tasty-tokyo-japanese-cuisine",
      "poi_latitude": "28.326992",
      "poi_longitude": "-82.29735699999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 352-668-9788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-Lh6V-twogRa5XeL-j3sIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_73d3a05f-ba4b-4ff4-a748-c34552bd684c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Kafe Kokopelli",
      "poi_type": "Restaurants",
      "poi_address": "37940 Live Oak Ave, Dade City, FL 33523, USA",
      "poi_short_description": "Unusual, historic setting for New American dining, from upscale entrees to creative sandwiches.",
      "poi_long_description": "Unusual, historic setting for New American dining, from upscale entrees to creative sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b0-fd6e-7088-8dd3-c8fd30d15bc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b0-fd6e-7088-8dd3-c8fd30d15bc8",
        "storage_key": "property/6767906449167755/01a086b0-fd6e-7088-8dd3-c8fd30d15bc8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kafekokopelli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2010982359758514912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kafe-kokopelli",
      "poi_latitude": "28.3650074",
      "poi_longitude": "-82.188034",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 352-523-0055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4A-pJlU3YgR4Kr7Ms1x6Bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4250b9e7-09a7-4a61-8403-3aadb7b0b238",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Steph's Southern Soul Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "14519 5th St, Dade City, FL 33523, USA",
      "poi_short_description": "Relaxed, homey spot for Southern classics served cafeteria style including fried chicken & veggies.",
      "poi_long_description": "Relaxed, homey spot for Southern classics served cafeteria style including fried chicken & veggies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b0-fa05-72cd-b0f1-c11666315f18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b0-fa05-72cd-b0f1-c11666315f18",
        "storage_key": "property/6767906449167755/01a086b0-fa05-72cd-b0f1-c11666315f18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stephssouthernsoul.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158720633730669891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stephs-southern-soul-restaurant",
      "poi_latitude": "28.3692741",
      "poi_longitude": "-82.18770599999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 352-437-5907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8d56fb216d39",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8d56fb216d39.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRo5y5BU3YgRQ502Rq4H1is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "custom_8e9da193-77c7-4d10-9916-12f7b03cc127",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Publix Super Market at The Market at Mirada",
      "poi_type": "Shopping & Retail",
      "poi_address": "30841 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-c5d5-7409-8751-85efcc7cc366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-c5d5-7409-8751-85efcc7cc366",
        "storage_key": "property/6767906449167755/01a086ae-c5d5-7409-8751-85efcc7cc366.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1742&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=12481644149929695859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-market-at-mirada",
      "poi_latitude": "28.3271061",
      "poi_longitude": "-82.2960073",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-588-1170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-eab2-700a-bdf4-a0983deb821c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-eab2-700a-bdf4-a0983deb821c",
        "storage_key": "property/6767906449167755/01a086ae-eab2-700a-bdf4-a0983deb821c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYywNtuitwogRc1pkSTm1N60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_25ce2298-d425-49ec-8dee-f221539b5236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "The Market at Mirada",
      "poi_type": "Shopping & Retail",
      "poi_address": "30945 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Shopping mall featuring a supermarket, restaurants, and other retailers.",
      "poi_long_description": "Shopping mall featuring a supermarket, restaurants, and other retailers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-0b7d-70a5-b646-59756d4e2acc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-0b7d-70a5-b646-59756d4e2acc",
        "storage_key": "property/6767906449167755/01a086b1-0b7d-70a5-b646-59756d4e2acc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10936098821152257906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-market-at-mirada",
      "poi_latitude": "28.326903",
      "poi_longitude": "-82.2959",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8a2f75964781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8a2f75964781",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8a2f75964781.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv6uTafGtwogRcjdZl-_TxJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cf329c52-cdaf-40f3-996d-f5ed88bee4a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "32581 Co Rd 52, San Antonio, FL 33576, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-0728-705a-a47d-45b15883b440.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-0728-705a-a47d-45b15883b440",
        "storage_key": "property/6767906449167755/01a086b1-0728-705a-a47d-45b15883b440.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/fl/san-antonio/13606",
      "poi_directions_map_url": "https://maps.google.com/?cid=13089568400455403036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "28.3324492",
      "poi_longitude": "-82.27725450000001",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-461-7020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea89-72ec-a6b7-8a2f75964781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea89-72ec-a6b7-8a2f75964781",
        "storage_key": "property/6767906449167755/01a086ae-ea89-72ec-a6b7-8a2f75964781.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ19K2Po2uwogRHIZS1Bt9p7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_26bbf93f-78e8-4789-9430-6c590e87aefc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Max's Pet Market & Salon (Mirada location)",
      "poi_type": "Shopping & Retail",
      "poi_address": "30945 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Pet store specializing in all-natural food and supplies, plus cage-free grooming.",
      "poi_long_description": "Pet store specializing in all-natural food and supplies, plus cage-free grooming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-08b5-72c2-b27f-a25867c6f377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-08b5-72c2-b27f-a25867c6f377",
        "storage_key": "property/6767906449167755/01a086b1-08b5-72c2-b27f-a25867c6f377.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://maxspetmarketandsalon.com/mirada/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17888755060308651376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maxs-pet-market--salon-mirada-location",
      "poi_latitude": "28.3267854",
      "poi_longitude": "-82.2953677",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-437-6677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5",
        "storage_key": "property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-xP4_atwogRcC2r2_KfQfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_care"
    },
    {
      "id": "custom_1f08017c-ab90-4654-a704-6b21f54d3cac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Publix Pharmacy at The Market at Mirada",
      "poi_type": "Health and Wellness",
      "poi_address": "30841 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Publix in-store pharmacy at The Market at Mirada on Mirada Boulevard.",
      "poi_long_description": "Publix in-store pharmacy at The Market at Mirada on Mirada Boulevard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-1b7a-723d-b6de-78cfaf1cad4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-1b7a-723d-b6de-78cfaf1cad4a",
        "storage_key": "property/6767906449167755/01a086b1-1b7a-723d-b6de-78cfaf1cad4a.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=17874067921549716147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-the-market-at-mirada",
      "poi_latitude": "28.3270494",
      "poi_longitude": "-82.2959644",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-588-1199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3daa-7658-9844-619e2cbff0db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086b1-3daa-7658-9844-619e2cbff0db",
        "storage_key": "property/6767906449167755/01a086b1-3daa-7658-9844-619e2cbff0db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XAFu4WtwogRs-os4xJyDfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1831ba09-5784-4fda-9914-54e741478c02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Magnolia Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12525 Curley St, San Antonio, FL 33576, USA",
      "poi_short_description": "Independent pharmacy on Curley Street in San Antonio.",
      "poi_long_description": "Independent pharmacy on Curley Street in San Antonio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-06f3-74ca-83db-6189a7a9d915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-06f3-74ca-83db-6189a7a9d915",
        "storage_key": "property/6767906449167755/01a086b1-06f3-74ca-83db-6189a7a9d915.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://www.magnoliapharmacyllc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6844069061045025168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-pharmacy",
      "poi_latitude": "28.3398906",
      "poi_longitude": "-82.2747321",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-588-3330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3daa-7658-9844-619e2cbff0db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086b1-3daa-7658-9844-619e2cbff0db",
        "storage_key": "property/6767906449167755/01a086b1-3daa-7658-9844-619e2cbff0db.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QPtGkKswogRkHnUsYwE-14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_885b2e59-10b8-4333-9e7e-1bbd47b26d17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "AdventHealth Dade City",
      "poi_type": "Health and Wellness",
      "poi_address": "13100 Fort King Rd, Dade City, FL 33525, USA",
      "poi_short_description": "AdventHealth community hospital on Fort King Road in Dade City with a 24-hour emergency department.",
      "poi_long_description": "AdventHealth community hospital on Fort King Road in Dade City with a 24-hour emergency department.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-d962-724d-91aa-a4209cc62b95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-d962-724d-91aa-a4209cc62b95",
        "storage_key": "property/6767906449167755/01a086ae-d962-724d-91aa-a4209cc62b95.webp",
        "width": 387,
        "height": 391
      },
      "poi_business_url": "https://www.adventhealth.com/locations/hospitals/dade-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=11382911786190021435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-dade-city",
      "poi_latitude": "28.3479806",
      "poi_longitude": "-82.20052",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 352-521-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-eab1-7169-a97d-57d1bdfb6c63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-eab1-7169-a97d-57d1bdfb6c63",
        "storage_key": "property/6767906449167755/01a086ae-eab1-7169-a97d-57d1bdfb6c63.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWc8K2pWkiogRO6N21fU5-J0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_039aafe9-6991-4868-ba4d-6ebe483c6fce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "AdventHealth Primary Care at Dade City",
      "poi_type": "Health and Wellness",
      "poi_address": "13933 17th St Ste 101, Dade City, FL 33525, USA",
      "poi_short_description": "AdventHealth primary care practice on 17th Street in Dade City.",
      "poi_long_description": "AdventHealth primary care practice on 17th Street in Dade City.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ahmgtampabay.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4399926255938106178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-primary-care-at-dade-city",
      "poi_latitude": "28.3603675",
      "poi_longitude": "-82.200701",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 352-567-6763",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5",
        "storage_key": "property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgaUE6KZU3YgRQvMaM56tDz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b22b6f48-8c53-4634-aaa5-e0788c876cab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "CrossFit HCP",
      "poi_type": "Health and Wellness",
      "poi_address": "37852 Robinson Ave, Dade City, FL 33523, USA",
      "poi_short_description": "CrossFit gym on Robinson Avenue in Dade City.",
      "poi_long_description": "CrossFit gym on Robinson Avenue in Dade City.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-1f56-73a5-8c10-055b55d0ecd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-1f56-73a5-8c10-055b55d0ecd9",
        "storage_key": "property/6767906449167755/01a086b1-1f56-73a5-8c10-055b55d0ecd9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://crossfithcp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7458059539895169425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-hcp",
      "poi_latitude": "28.3666049",
      "poi_longitude": "-82.1897202",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5",
        "storage_key": "property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUKVniqvwogRkTEqFaNZgGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cce06c9c-ea0e-4447-a467-48cccfd5f04f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "BayCare Hospital Wesley Chapel",
      "poi_type": "Health and Wellness",
      "poi_address": "4501 Bruce B Downs Blvd, Wesley Chapel, FL 33544, USA",
      "poi_short_description": "BayCare hospital on Bruce B. Downs Boulevard in Wesley Chapel with a 24-hour emergency department.",
      "poi_long_description": "BayCare hospital on Bruce B. Downs Boulevard in Wesley Chapel with a 24-hour emergency department.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-352e-730f-9424-450fde5351a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-352e-730f-9424-450fde5351a3",
        "storage_key": "property/6767906449167755/01a086b1-352e-730f-9424-450fde5351a3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://baycare.org/locations/hospitals/baycare-hospital-wesley-chapel/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=BayCare_Hospital_Wesley_Chapel",
      "poi_directions_map_url": "https://maps.google.com/?cid=16453829391510237874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baycare-hospital-wesley-chapel",
      "poi_latitude": "28.2232219",
      "poi_longitude": "-82.3560263",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-914-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-eab1-7169-a97d-57d1bdfb6c63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-eab1-7169-a97d-57d1bdfb6c63",
        "storage_key": "property/6767906449167755/01a086ae-eab1-7169-a97d-57d1bdfb6c63.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9os41-xwogRsnLZy6e-V-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_490a4480-ab6f-4672-b61b-82d9500b50bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Saint Anthony Catholic School",
      "poi_type": "Education",
      "poi_address": "12155 Joe Herrmann Dr, San Antonio, FL 33576, USA",
      "poi_short_description": "Catholic school on Joe Herrmann Drive in San Antonio.",
      "poi_long_description": "Catholic school on Joe Herrmann Drive in San Antonio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-10ad-739e-8aae-bcc9664dd111.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-10ad-739e-8aae-bcc9664dd111",
        "storage_key": "property/6767906449167755/01a086b1-10ad-739e-8aae-bcc9664dd111.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://sacsfl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5209895793881475086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-anthony-catholic-school",
      "poi_latitude": "28.3347707",
      "poi_longitude": "-82.27184030000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-588-3041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU1w2_0KswogRDmgbD59ETUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_96c813dc-b914-433b-b190-803fa50d5e29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Innovation Academy & Preschool",
      "poi_type": "Education",
      "poi_address": "11609 Boys Village Ln, San Antonio, FL 33576, USA",
      "poi_short_description": "Preschool and child-care center on Boys Village Lane in San Antonio.",
      "poi_long_description": "Preschool and child-care center on Boys Village Lane in San Antonio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-1671-701d-8512-0a68c8f55ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-1671-701d-8512-0a68c8f55ff3",
        "storage_key": "property/6767906449167755/01a086b1-1671-701d-8512-0a68c8f55ff3.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://innovationacademypreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12727575480948915432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "innovation-academy--preschool",
      "poi_latitude": "28.3264897",
      "poi_longitude": "-82.2774835",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-588-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVU3tK86twogR6HzuYXduobA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_8b4c3888-688d-45f6-b9dd-837eb4eaee39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "San Antonio Elementary School",
      "poi_type": "Education",
      "poi_address": "32416 Darby Rd, Dade City, FL 33525, USA",
      "poi_short_description": "Public elementary school on Darby Road, Pasco County Schools.",
      "poi_long_description": "Public elementary school on Darby Road, Pasco County Schools.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://saes.pasco.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7316718338497960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-elementary-school",
      "poi_latitude": "28.3540033",
      "poi_longitude": "-82.2794698",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-524-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb32a1nKswogRqN18PYT-GQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d036a808-ac39-4af9-b8cb-f3c452dc6471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Saint Leo University",
      "poi_type": "Education",
      "poi_address": "33701 County Road 52, St Leo, FL 33574, USA",
      "poi_short_description": "Private university on County Road 52 in St. Leo, the closest college campus to the community.",
      "poi_long_description": "Private university on County Road 52 in St. Leo, the closest college campus to the community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-cabf-7539-8428-65f6b14d4ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-cabf-7539-8428-65f6b14d4ed3",
        "storage_key": "property/6767906449167755/01a086ae-cabf-7539-8428-65f6b14d4ed3.webp",
        "width": 599,
        "height": 337
      },
      "poi_business_url": "https://www.saintleo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=234912551360242724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-leo-university",
      "poi_latitude": "28.3383111",
      "poi_longitude": "-82.25728579999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 352-588-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ-SRRvWswogRJKQbibiTQgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4fbd100f-a897-4c7e-a824-a3e4aacfcfb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Pasco High School",
      "poi_type": "Education",
      "poi_address": "36850 Co Rd 52, Dade City, FL 33525, USA",
      "poi_short_description": "Public high school on County Road 52 in Dade City, Pasco County Schools.",
      "poi_long_description": "Public high school on County Road 52 in Dade City, Pasco County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-0fc1-77a8-9594-a973c693ac2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-0fc1-77a8-9594-a973c693ac2b",
        "storage_key": "property/6767906449167755/01a086b1-0fc1-77a8-9594-a973c693ac2b.webp",
        "width": 984,
        "height": 656
      },
      "poi_business_url": "https://phs.pasco.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11423972288214935989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasco-high-school",
      "poi_latitude": "28.3523475",
      "poi_longitude": "-82.205347",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 352-524-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUX2dQFdT3YgRtSn18kQaip4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_52dc29a4-9ca5-4cda-8632-e26dfc56d8c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Pasco Middle School",
      "poi_type": "Education",
      "poi_address": "13925 14th St, Dade City, FL 33525, USA",
      "poi_short_description": "Public middle school on 14th Street in Dade City, Pasco County Schools.",
      "poi_long_description": "Public middle school on 14th Street in Dade City, Pasco County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-0eee-753d-877f-893882c0b8ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-0eee-753d-877f-893882c0b8ba",
        "storage_key": "property/6767906449167755/01a086b1-0eee-753d-877f-893882c0b8ba.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "http://pms.pasco.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17080950474722222024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasco-middle-school",
      "poi_latitude": "28.361043",
      "poi_longitude": "-82.19662590000002",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 352-524-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ7QkcqFU3YgRyJ_bP_W5C-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_41cfa4b2-766f-4a81-aa47-983f789ce842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Pasco-Hernando State College, East Campus",
      "poi_type": "Education",
      "poi_address": "36727 Blanton Rd, Dade City, FL 33523, USA",
      "poi_short_description": "Pasco-Hernando State College's East Campus on Blanton Road in Dade City.",
      "poi_long_description": "Pasco-Hernando State College's East Campus on Blanton Road in Dade City.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-cd17-71f0-bd6e-a3d331201ef0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-cd17-71f0-bd6e-a3d331201ef0",
        "storage_key": "property/6767906449167755/01a086ae-cd17-71f0-bd6e-a3d331201ef0.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://phsc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=29607053401336723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasco-hernando-state-college-east-campus",
      "poi_latitude": "28.3791586",
      "poi_longitude": "-82.2165562",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 727-847-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9b-734f-99eb-0ea307ecc744",
        "storage_key": "property/6767906449167755/01a086ae-ea9b-734f-99eb-0ea307ecc744.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1_h59UqrwogRkyvVTHUvaQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4236b226-6097-4c9c-afa6-35bb0cfe7cdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Mirada Lagoon",
      "poi_type": "Entertainment",
      "poi_address": "31461 Mirada Blvd, San Antonio, FL 33576, USA",
      "poi_short_description": "Man-made lake offering swimming, paddle boarding and kayaking, plus bars and a sandy beach here and there .",
      "poi_long_description": "Man-made lake offering swimming, paddle boarding and kayaking, plus bars and a sandy beach here and there .",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-cdc8-741e-8760-507e4f8f8ed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-cdc8-741e-8760-507e4f8f8ed9",
        "storage_key": "property/6767906449167755/01a086ae-cdc8-741e-8760-507e4f8f8ed9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.metrolagoons.com/lagoon/mirada/?utm_medium=organic&utm_source=google&utm_campaign=business-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16423128361630679250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mirada-lagoon",
      "poi_latitude": "28.3160132",
      "poi_longitude": "-82.2941805",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-444-5221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5",
        "storage_key": "property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1OLBO2twogR0sCjPzus6uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_f535fc83-877f-480d-9ad7-94c2fbb67ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Busch Gardens Tampa Bay",
      "poi_type": "Entertainment",
      "poi_address": "10165 McKinley Dr, Tampa, FL 33612, USA",
      "poi_short_description": "Venerable theme park with thrill rides, African animals, live entertainment & kiddie attractions.",
      "poi_long_description": "Venerable theme park with thrill rides, African animals, live entertainment & kiddie attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-1604-71b1-ba82-ae0a1c3f8654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-1604-71b1-ba82-ae0a1c3f8654",
        "storage_key": "property/6767906449167755/01a086b1-1604-71b1-ba82-ae0a1c3f8654.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://buschgardens.com/tampa?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152398480662399058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "busch-gardens-tampa-bay",
      "poi_latitude": "28.037066",
      "poi_longitude": "-82.4194607",
      "poi_miles_from_property": "26.7 mi",
      "poi_walking_minutes": "9 hours 44 mins",
      "poi_biking_minutes": "2 hours 10 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 813-884-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5",
        "storage_key": "property/6767906449167755/01a086ae-ea9a-70fe-b9c7-3593d2dc1fb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRo4DU_GwogRUgjhMAj-pag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a9893c69-fea1-406a-a89a-6276f389a1fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "San Antonio Athletic Complex & Community Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12750 Oak St, San Antonio, FL 33576, USA",
      "poi_short_description": "Community park featuring shaded baseball fields and playgrounds.",
      "poi_long_description": "Community park featuring shaded baseball fields and playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-df4a-76f8-b783-bc2e1ab78a5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ae-df4a-76f8-b783-bc2e1ab78a5b",
        "storage_key": "property/6767906449167755/01a086ae-df4a-76f8-b783-bc2e1ab78a5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pascocountyfl.gov/_T22_R41.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=17855370047638520408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-athletic-complex-community-garden",
      "poi_latitude": "28.343907",
      "poi_longitude": "-82.276836",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 727-494-4892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea88-735f-a397-f495fac91994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea88-735f-a397-f495fac91994",
        "storage_key": "property/6767906449167755/01a086ae-ea88-735f-a397-f495fac91994.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7pejFxT3YgRWMKk3nQEy_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_098e5f5c-4cc3-419c-a41c-7045e1c5cd16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Withlacoochee River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12449 Withlacoochee Blvd, Dade City, FL 33525, USA",
      "poi_short_description": "406 acres of forested park with a river, offering trails, fishing, wildlife & an observation tower.",
      "poi_long_description": "406 acres of forested park with a river, offering trails, fishing, wildlife & an observation tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-203b-77e3-a415-c624bade2ffc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-203b-77e3-a415-c624bade2ffc",
        "storage_key": "property/6767906449167755/01a086b1-203b-77e3-a415-c624bade2ffc.webp",
        "width": 1159,
        "height": 1280
      },
      "poi_business_url": "https://www.pascocountyfl.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7002332877537500945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "withlacoochee-river-park",
      "poi_latitude": "28.3501678",
      "poi_longitude": "-82.1287342",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 352-567-0264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea88-735f-a397-f495fac91994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea88-735f-a397-f495fac91994",
        "storage_key": "property/6767906449167755/01a086ae-ea88-735f-a397-f495fac91994.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2kKQFFR3YgREV-p9KZILWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6f5c218-60ff-4b49-bf01-559a4359ad8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Withlacoochee State Trail - Owensboro Junction Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Dade City, FL 33523, USA",
      "poi_short_description": "Paved trail that's 46 miles long, with a picnic table at one end.",
      "poi_long_description": "Paved trail that's 46 miles long, with a picnic table at one end.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-2214-72aa-ba8c-809f1e273c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-2214-72aa-ba8c-809f1e273c92",
        "storage_key": "property/6767906449167755/01a086b1-2214-72aa-ba8c-809f1e273c92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4129835203949915211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "withlacoochee-state-trail---owensboro-junction-trailhead",
      "poi_latitude": "28.4464059",
      "poi_longitude": "-82.1890593",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-ea88-735f-a397-f495fac91994.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086ae-ea88-735f-a397-f495fac91994",
        "storage_key": "property/6767906449167755/01a086ae-ea88-735f-a397-f495fac91994.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97MOomFV3YgRS2xWuDwfUDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_41b35e8c-40ad-4cb0-8555-8ac989f9768f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Tampa International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4100 George J. Bean Pkwy, Tampa, FL 33607, USA",
      "poi_short_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_long_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-2c1e-73e3-ad09-b5b330871af9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-2c1e-73e3-ad09-b5b330871af9",
        "storage_key": "property/6767906449167755/01a086b1-2c1e-73e3-ad09-b5b330871af9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampaairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816785868724491529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-international-airport",
      "poi_latitude": "27.9768646",
      "poi_longitude": "-82.5302804",
      "poi_miles_from_property": "36.1 mi",
      "poi_walking_minutes": "13 hours 15 mins",
      "poi_biking_minutes": "3 hours 25 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 813-870-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3da9-778e-bbc4-d220adfca5ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086b1-3da9-778e-bbc4-d220adfca5ea",
        "storage_key": "property/6767906449167755/01a086b1-3da9-778e-bbc4-d220adfca5ea.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0Sek0bCwogRCdUBxgiEW3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_088e208c-703d-4673-88d5-84a2f3b6535d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "Wiregrass Park n Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Wesley Chapel, FL 33543, USA",
      "poi_short_description": "Commuter park-and-ride lot in Wesley Chapel served by Pasco County Public Transportation.",
      "poi_long_description": "Commuter park-and-ride lot in Wesley Chapel served by Pasco County Public Transportation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3116-747d-b605-1b278502cd21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-3116-747d-b605-1b278502cd21",
        "storage_key": "property/6767906449167755/01a086b1-3116-747d-b605-1b278502cd21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=826771168819801753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wiregrass-park-n-ride",
      "poi_latitude": "28.19111",
      "poi_longitude": "-82.3494",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3dd0-7289-9979-f59707949a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086b1-3dd0-7289-9979-f59707949a77",
        "storage_key": "property/6767906449167755/01a086b1-3dd0-7289-9979-f59707949a77.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2_z4tmwwogRme4JZP9HeQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a8e8c706-2840-46ef-a9f6-815f978bbe88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755",
      "source": "custom",
      "poi_name": "East Pasco Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14236 6th St, Dade City, FL 33523, USA",
      "poi_short_description": "Pasco County government offices on 6th Street in Dade City.",
      "poi_long_description": "Pasco County government offices on 6th Street in Dade City.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-31b7-7379-a4ab-4887ca13b6df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086b1-31b7-7379-a4ab-4887ca13b6df",
        "storage_key": "property/6767906449167755/01a086b1-31b7-7379-a4ab-4887ca13b6df.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.pascocountyfl.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13760333638479812555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-pasco-government-center",
      "poi_latitude": "28.3658189",
      "poi_longitude": "-82.1880133",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 352-523-2411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-3dc9-76df-856d-339f4f358f5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a086b1-3dc9-76df-856d-339f4f358f5b",
        "storage_key": "property/6767906449167755/01a086b1-3dc9-76df-856d-339f4f358f5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZUcriplU3YgRy5dy8ImG9r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-a16b-7044-929d-8d417751bd33",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Terra View Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755"
    },
    {
      "lead_collector_id": "01a0abe0-a1e6-730a-afe9-f87ea1946f7e",
      "lead_source": "LANDING_PAGE",
      "name": "Terra View Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167755"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977296781"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M75VZSRF"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57146748823"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977296781",
  "custom_google_gtm_id": "GTM-M75VZSRF",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57146748823",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_audioeye_site_id": "472f69d3-a3d1-4b4c-9f0d-beec0f1fa2f5",
  "custom_audioeye_site_hash": "75080bcc6c400508ee7178f4321ad085"
};

export const generatedAt = '2026-10-29T18:32:00.017Z';
